export default {
    add_to_egisz: "Саламаттык сактоо чөйрөсүндөгү бирдиктүү мамлекеттик маалымат системасына кошуу",
    comment_to_deal: "Келишимге комментарий",
    diagnosis_comments: "Диагнозго комментарий",
    download_all: "Барын жүктөп алуу",
    edit_patient: "Пациентти түзөтүү",
    egisz: "Саламаттык сактоо чөйрөсүндөгү бирдиктүү мамлекеттик маалымат системасы",
    for_rework: "Кайра иштеп чыгууга",
    funnel: "Воронка",
    go_to_egisz_page: "Бирдиктүү мамлекеттик саламаттык сактоо маалымат системасынын барагына өтүңүз",
    list: "Тизме",
    main_doctor: "Башкы дарыгер",
    patient_rejected_to_send_to_egisz: "Бейтап ССЧБММСга маалыматтарды тапшыруудан баш тартты",
    prepare_document_for_sending_to_egisz: "ССЧБММСга жөнөтүү үчүн документти даярдадыңызбы?",
    processing_status: "Иштетүү статусу",
    representative_relation: "Өкүлдүн бейтапка болгон мамилеси кандай?",
    requires_attention: "Көңүл буруу керек",
    send_all: "Баарын жөнөтүү",
    send_to_egisz: "ССЧБММСга жөнөтүү",
    sent_to_egisz: "ССЧБММСга жөнөтүлдү",
    show_more: "Кененирээк маалымат",
    show_only_not_sent: "Жөнөтүлбөгөндөрдү гана көрсөтүү",
    sign: "Кол коюу",
    sign_all: "Баарына кол коюу",
    signed_by_doctor: "Дарыгер тарабынан кол коюулду",
    signed_by_main_doctor: "Башкы дарыгер тарабынан кол коюулду",
    to_egisz_page: "ССЧБММС барагында",
    to_rework: "Кайра иштеп чыгууга",
    to_sign: "Кол коюу үчүн"
}
